// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPresignUrlResponse
 */
export interface IPresignUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof IPresignUrlResponse
     */
    upload_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IPresignUrlResponse
     */
    file_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPresignUrlResponse
     */
    object_key?: string;
}

/**
 * Check if a given object implements the IPresignUrlResponse interface.
 */
export function instanceOfIPresignUrlResponse(value: object): value is IPresignUrlResponse {
    return true;
}

export function IPresignUrlResponseFromJSON(json: any): IPresignUrlResponse {
    return IPresignUrlResponseFromJSONTyped(json, false);
}

export function IPresignUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPresignUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'upload_url': json['upload_url'] == null ? undefined : json['upload_url'],
        'file_name': json['file_name'] == null ? undefined : json['file_name'],
        'object_key': json['object_key'] == null ? undefined : json['object_key'],
    };
}

export function IPresignUrlResponseToJSON(json: any): IPresignUrlResponse {
    return IPresignUrlResponseToJSONTyped(json, false);
}

export function IPresignUrlResponseToJSONTyped(value?: IPresignUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'upload_url': value['upload_url'],
        'file_name': value['file_name'],
        'object_key': value['object_key'],
    };
}

